import { OperationCode } from "../enum/operation-code";

export class VinValidation {
    
    operation = OperationCode.CAR;
    country: string;
    vins: string[] = [];

    constructor() {
	}
}